<template>
  <div class="tour-button-wrap hide-for-print">
    <div class="tour-button" @click="$emit('clicked')">i</div>
    <transition name="fade">
        <div v-if="$store.state.showTourTooltip" class="tour-button__help">{{ $Strings('tour_tooltip') }}</div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'tour-button',
  data () {
    return {
      timer: false
    }
  },
  watch: {
    '$store.state.showTourTooltip' () {
      this.timer = setTimeout(() => {
        this.$store.state.showTourTooltip = false
      }, 3000)
    }
  }
}
</script>

<style lang="scss">
  @import '~@/components/sass/shared/colors';

    .tour-button-wrap{
        position: relative;
        z-index: 500;
    }

    .tour-button__help {
        position: absolute;
        left: 22px;
        top: -8px
    }

    .tour-button {
        background: $blue-dark;
        border-radius: 50%;
        color: $white;
        cursor: pointer;
        font-size: 14px;
        font-weight: bold;
        line-height: 22px;
        text-align: center;
        transition: background 150ms ease;
        height: 22px;
        width: 22px;

        &:hover {
            background: $blue;
        }
    }

    .tour-button__help {
        background: $blue-dark;
        color: $white;
        left: 40px;
        padding: 0.5em 5em 0.5em 1em;
        position: absolute;
        top: -7px;
        white-space: nowrap;
    }
    .tour-button__help:after {
        right: 100%;
        top: 50%;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
        border-color: $white;
        border-right-color: $blue-dark;
        border-width: 5px;
        margin-top: -5px;
    }
</style>



// WEBPACK FOOTER //
// src/components/tour/tourButton.vue